<template>
  <v-select
    :items="opcoes"
    label="Pedidos Recorrentes"
    item-text="text"
    item-value="value"
    v-model="opcaoSelecionada"
  />
</template>

<script>
export default {
  name: 'FiltroPedidosRecorrentes',
  data() {
    return {
      opcoes: [
        {
          text: 'Todos os estabelecimentos',
          value: null
        },
        {
          text: 'Sim',
          value: true
        },
        {
          text: 'Não',
          value: false
        }
      ],
      opcaoSelecionada: true
    }
  },
  mounted() {
    this.emitirOpcaoSelecionada()
  },
  watch: {
    opcaoSelecionada() {
      this.emitirOpcaoSelecionada()
    }
  },
  methods: {
    emitirOpcaoSelecionada() {
      this.$emit('filtrar-pedidos-recorrentes', {
        pedidos_recorrentes: this.opcaoSelecionada
      })
    }
  }
}
</script>
